export const FETCH_CARDS = 'FETCH_CARDS';
export const FETCH_CARDS_START_LOADING = 'FETCH_CARDS_START_LOADING';
export const FETCH_CARDS_FINISH_LOADING = 'FETCH_CARDS_FINISH_LOADING';
export const FETCH_CARDS_SUCCESS = 'FETCH_CARDS_SUCCESS';
export const FETCH_CARDS_NEXT_PAGE = 'FETCH_CARDS_NEXT_PAGE';
export const FETCH_CARDS_ERROR = 'FETCH_CARDS_ERROR';

export const ADD_CARD_HIELOCO = 'ADD_CARD_HIELOCO';
export const DELETE_CARD = 'DELETE_CARD';
export const DELETE_CARD_HIELOCO = 'DELETE_CARD_HIELOCO';
